<mat-icon matTooltip="{{ 'GridTable.Filter.FilterGuid' | translate }}" [matMenuTriggerFor]="menu">filter_alt</mat-icon>
<mat-menu #menu="matMenu" class="p-3">
  <form [formGroup]="filterForm" (click)="$event.stopPropagation();">
    <div class="col">
      <mat-form-field>
        <mat-label>{{ 'GridTable.Filter.FilterType' | translate }}</mat-label>
        <mat-select [formControl]="filterTypeControl" [value]="filterTypeControl">
          <mat-option *ngFor="let option of filterOptions" [value]="option.value">
            {{ option.translationKey | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
  <ng-container *ngIf="this.filterTypeControl.value !== guidContainsFilter; else arrayFilter">
    <form [formGroup]="guidForm" (click)="$event.stopPropagation();">
      <div class="col">
        <mat-form-field>
          <mat-label>{{ 'GridTable.Filter.ChooseValue' | translate }}</mat-label>
          <mat-select [formControl]="guidControl">
            <mat-option *ngFor="let option of options | async" [value]="option.id">
              {{option.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </ng-container>
  <ng-template #arrayFilter>
    <form [formGroup]="multipleGuidForm" (click)="$event.stopPropagation();">
      <div class="col">
        <mat-form-field>
          <mat-label>{{ 'GridTable.Filter.ChooseValue' | translate }}</mat-label>
          <mat-select [formControl]="multipleGuidControl" multiple>
            <mat-option *ngFor="let option of options | async" [value]="option.id">
              {{option.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </ng-template>
  <div class="col" style="display: flex; justify-content: flex-end;">
    <mat-icon matTooltip="{{ 'GridTable.Filter.Cancel' | translate }}" style="cursor: pointer;" color="primary"
      (click)="onCancel()">
      clear
    </mat-icon>
    <mat-icon matTooltip="{{ 'GridTable.Filter.ApplyFilter' | translate }}" style="cursor: pointer;" color="primary"
      (click)="onSubmit($event)">
      check
    </mat-icon>
    <mat-icon matTooltip="{{ 'GridTable.Filter.Clear' | translate }}" style="cursor: pointer;" color="primary"
      *ngIf="this.currentValue | async" (click)="onClear()">
      delete
    </mat-icon>
  </div>
</mat-menu>
